<template>
  <footer :class="isSP ? 'footer--sp' : 'footer--pc'" v-if="isDisplay">
    ©2019 nukumo
  </footer>
</template>

<script>
// ヘッダーを表示させないページ名
const NOT_DISPLAY = [
  'error',
  'notfound'
]

export default {
  computed: {
    /**
     * @return {Boolean} SPかどうか
     */
    isSP () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    },
    /**
     * @return {Boolean} ヘッダーを表示させるかどうか
     */
    isDisplay () {
      return !NOT_DISPLAY.includes(this.$route.name)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.footer {
  width: 100vw;
  font-size: 1.4rem;
  color: $white_color;
  text-align: center;
  background-color: $gray_darken_color;
  &--sp {
    @extend .footer;
    height: $footer_height_sp;
    line-height: $footer_height_sp;
  }
  &--pc {
    @extend .footer;
    height: $footer_height_pc;
    line-height: $footer_height_sp;
  }
}
</style>
